import {gsap} from "../../../libs/gsap/all.js";
import * as PIXI from "pixi.js";
import 'pixi.js/math-extras';
import {Point} from 'pixi.js';

// Constructor
export class GameH_Item extends PIXI.Container {

  constructor(data, game) {
    super();

    this.game = game;
    this.data = data;

    this.id = this.data.asset;
    this.droppedInZone = null;
    this.dropZoneId = this.data.dropZone;
    this.dropPosition = this.data.dropPosition;
    this.zIndex = 0;

    this.position.set(this.data.basePosition.x, this.data.basePosition.y);

    this.build();
    // this.generateBackgroundArea();
  }

  build() {

    const image = new PIXI.Sprite(this.game.assets[this.data.asset]);
    this.addChild(image);

    this.pivot.set(this.width / 2, this.height / 2);

    this.originalPosition = new PIXI.Point().copyFrom(this.position); // copy original position to a variable for later

    this.generateBackgroundArea();
    this.buildAnimations();
  }

  enable() {
    this.eventMode = "static";
    this.cursor = 'grab';
  }

  disable() {
    this.eventMode = "none";
    this.cursor = 'static';
  }

  buildAnimations() {

    // this.bgArea.alpha = 0;

    this.inAnimation = gsap.fromTo(this, {
        pixi: {
          scale: 0,
          alpha: 0,
        },
      }, {
        pixi: {
          scale: 1,
          alpha: 1,
        },
        ease: "power1.inOut",
        immediateRender: true,
        paused: true,
        duration: 1,
        onComplete: () => {
          // enable() is called in GameH animation, prevent us from dragging when not ready
          //this.enable();
          // this.bgArea.alpha = 1;
        }
      }
    );
  }

  animateIn() {
    if (this.inAnimation) {
      this.inAnimation.play();
    }
  }

  hide() {
    gsap.to([this, this.bgArea], {
        pixi: {
          alpha: 0
        },
        duration: 0.25,
        delay: 0.70,
        ease: "power1.inOut"
      }
    )
  }

  pickedUp() {
    this.alpha = 0.75;
    this.zIndex = 1;
    this.cursor = 'grabbing';

    console.log(this.bgArea)
    gsap.to(this.bgArea, {
        pixi: {
          alpha: 1
        },
        ease: "quad.out",
        duration: 0.1,
      }
    )
  }

  released() {
    this.alpha = 1;
    this.zIndex = 0;
    this.cursor = 'grab';
  }

  animateDropped(dropZone) {
    // set tag position to the dropzone position
    // const dropZoneGlobalPos = dropZone.toGlobal(new PIXI.Point(0, 0)); // get the global position for the dropzone
    // const dropZoneLocalTranslated = this.parent.toLocal(dropZoneGlobalPos); // convert it to the relative position of the tags container
    // console.log(dropZoneGlobalPos);
    // console.log(dropZoneLocalTranslated);

    gsap.killTweensOf(this);
    gsap.killTweensOf(this.bgArea);
    // gsap.killTweensOf(this.bgArea);

    // this.bgArea.clear().roundRect(this.pivot.x, this.pivot.y, dropZone.width, dropZone.height, dropZone.height / 2).fill(0xFFEB5A);

    gsap.to(this, {
        pixi: {
          x: this.dropPosition.x,
          y: this.dropPosition.y,
          alpha: 0,
        },
        ease: "quad.out",
        duration: 0.25,
      }
    )

    // gsap.to(this.bgArea, {
    //     pixi: {
    //       scaleX: dropZone.width / this.bgArea.width,
    //       scaleY: dropZone.height / this.bgArea.height,
    //     },
    //     ease: "quad.out",
    //     duration: 0.25,
    //   }
    // )
  }

  getBgArea() {
    return this.bgArea;
  }

  generateBackgroundArea() {
    let bgArea = new PIXI.Sprite(this.game.assets[this.data.asset + "_bg"]);

    bgArea.alpha = 0;
    bgArea.position.set(this.originalPosition.x, this.originalPosition.y);
    bgArea.pivot.set(bgArea.width / 2, bgArea.height / 2);
    this.bgArea = bgArea;
  }

  resetPosition(duration = 0.25) {
    gsap.killTweensOf(this);
    gsap.killTweensOf(this.bgArea);

    gsap.to(this, {
        pixi: {
          x: this.originalPosition.x,
          y: this.originalPosition.y,
          alpha: 1,
        },
        ease: "quad.out",
        duration: duration,
        onComplete: () => {
          gsap.set(this.bgArea, {
              pixi: {
                alpha: 0
              }
            }
          )
        }
      }
    )


    // gsap.to(this.bgArea, {
    //     pixi: {
    //       scaleX: 1,
    //       scaleY: 1
    //     },
    //     ease: "quad.out",
    //     duration: duration,
    //   }
    // )
  }

  resetState(duration) {
    this.resetPosition(duration);
    this.droppedInZone = null;
  }

  // Reset the states so we can animate in again and start over
  reset() {
    if (this.inAnimation) {
      this.inAnimation.kill();
      this.inAnimation = null;
    }

    this.disable();
    this.resetState(0);

    // Rebuild the animations
    this.buildAnimations();
  }


}
